import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import firebase from 'firebase/compat/app';
import { Container } from "shards-react";
import * as actionConstants from "../actionConstants";
import ActivityIndicator from "../components/common/ActivityIndicator";

const IframeLayout = ({ children }) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [authState, setAuthState] = useState("loading"); // loading | authenticated | error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setAuthState("error");
      setErrorMessage("Missing authentication token.");
      return;
    }

    const authenticate = async () => {
      try {
        const validateEmbedToken = firebase
          .functions()
          .httpsCallable("validateEmbedToken");

        const result = await validateEmbedToken({ token });
        const { customToken, user, client, locations, users } = result.data;

        await firebase.auth().signInWithCustomToken(customToken);

        dispatch({ type: actionConstants.LOADED_USER, payload: user });
        dispatch({ type: actionConstants.LOADED_USERS, payload: users });
        dispatch({ type: actionConstants.LOADED_CLIENTS, payload: [client] });
        dispatch({ type: actionConstants.LOADED_LOCATIONS, payload: locations });

        // When the embed token pins the session to a single location,
        // preset the dashboard location filter so views default to it.
        if (user && user.location) {
          dispatch({
            type: actionConstants.SET_LOCATION_FILTER,
            payload: user.location,
          });
        }

        setAuthState("authenticated");
      } catch (err) {
        console.error("Embed auth failed:", err);
        setAuthState("error");
        setErrorMessage("Authentication failed. Please check your token.");
      }
    };

    authenticate();
  }, []);

  if (authState === "loading") {
    return (
      <Container fluid className="p-0">
        <div className="text-center py-5">
          <ActivityIndicator size="large" />
          <p className="mt-3 text-muted">Authenticating...</p>
        </div>
      </Container>
    );
  }

  if (authState === "error") {
    return (
      <Container fluid className="p-0">
        <div className="text-center py-5">
          <p style={{ color: "#E6492E", fontWeight: 500 }}>{errorMessage}</p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      {children}
    </Container>
  );
};

export default IframeLayout;
